import { render, staticRenderFns } from "./UserAdminDashboard.vue?vue&type=template&id=02d627c4&scoped=true&"
import script from "./UserAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./UserAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d627c4",
  null
  
)

export default component.exports